import { render } from "./AchievementItem.vue?vue&type=template&id=51b1de6a"
import script from "./AchievementItem.vue?vue&type=script&lang=js"
export * from "./AchievementItem.vue?vue&type=script&lang=js"

import "./AchievementItem.vue?vue&type=style&index=0&id=51b1de6a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__